import { Tag } from "antd";
import {
  QueryCondition,
  QueryOperation,
  SearchQuery,
} from "../../code/search-query/search-query";
import { DataColumn } from "../../controls/Data.default";
import { hasValue } from "../../utils/string";

export interface MetricsViewForm {
  readonly metricType?: string;
  readonly departmentUid?: string;
  readonly companyFiscalPeriodUid?: string;
}

export const metricsViewColumns: DataColumn[] = [
  {
    title: "Department",
    key: "departmentName",
    width: 160,
    sort: true,
    fixed: "left",
  },
  { title: "Period", key: "companyFiscalPeriodName", width: 160, sort: true },
  { title: "Metric", key: "metricType", width: 120, sort: true },
  {
    title: "Rate %",
    key: "rate",
    width: 90,
    sort: true,
    transform: (v) => (v == null ? "" : `${v}%`),
  },
  {
    title: "Risk band",
    key: "resultingBandLabel",
    width: 170,
    render: (_value, record) =>
      record.resultingBandLabel ? (
        <Tag color={record.resultingBandColor || "default"}>
          {record.resultingBandLabel}
        </Tag>
      ) : (
        <>—</>
      ),
  },
  { title: "Headcount", key: "headcount", width: 100 },
  { title: "Events", key: "eventCount", width: 90 },
];

export function mapMetricsViewQuery(values: MetricsViewForm): SearchQuery {
  const conditions: QueryCondition[] = Object.entries(values || {})
    .filter(([, value]) => hasValue(value))
    .map(([key, value]) => ({
      field: key,
      values: [value as string],
      operation: QueryOperation.Equal,
    }));

  return { conditions };
}
